<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-file-earmark-text"></i>
        Documentos
      </h6>
    </div>
    <div class="form-card__body">
    <div class="form-card__section">
      <label class="form-card__label">Habilitar documentos de venta</label>
      <div class="d-flex flex-column">
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_budget" type="checkbox" class="mr-2">
          Habilitar presupuestos
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_ordernote" type="checkbox" class="mr-2">
          Habilitar notas de pedido
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_shippingnote" type="checkbox" class="mr-2">
          Habilitar remitos
        </label>
      </div>
    </div>

    <div class="form-card__section">
      <label class="form-card__label">Habilitar documentos de compra</label>
      <div class="d-flex flex-column">
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_shippingpurchase" type="checkbox" class="mr-2">
          Habilitar remitos de compra
        </label>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bo_options'],
  data: function() {
    return {
      newbo_options: {}
    }
  },
  mounted: function () {
    this.newbo_options = this.bo_options;
  },
  methods: {

  }
}
</script>
